export const MOVE_COMBINATION_CONTINUE_CHANCE = 4 / 5;
export const MAX_MOVE_COMBINATION = 3;
